<template>
  <section class="login">
    <div class="logo-white logo-white--plain"></div>
    <form class="login__form" name="loginform">
      <input class="login__form__input" type="text" placeholder="User name" name="login" v-model="currentUser.username">
      <input class="login__form__input" type="password" placeholder="Password" name="password" v-model="currentUser.password">
      <button type="submit" name="submit" class="button login__form__button" @click.prevent="login(currentUser)">{{getResource('Log_In')}}</button>
      <a href="https://profiler.ricoh-portal.info/PasswordReminder.aspx?ClientApplicationId=6" target="_blank">{{getResource('ForgotPassword')}}</a>
      <p class="login__failure" v-if="login_failure">{{login_failure}}</p>
    </form>
    <header class="shape-header shape-header--padded">
      <h1>{{getResource('HomeHeader')}}</h1>
      <p>{{getResource('UnauthorizedInfo')}}</p>
    </header>
  </section>
  <div class="login-failure" v-if="login_failure">
    <div class="login-failure__block">
      <p class="login-failure__text">{{login_failure}}</p>
      <a @click="loginFailureReset" class="simple-button">Close</a>
    </div>
  </div>
</template>

<script>
import { getResource } from "../../vuex/helpers";
// import RouteHeader from "../../shared/RouteHeader";
import { login, loginFailureReset } from "./LoginActions";

export default {
  data: function () {
    return {
      currentUser: {
        username: "",
        password: "",
        returnUrl: window.location.href,
        grant_type: "password",
        company: ""
      }
    };
  },
  vuex: {
    getters: {
      login_failure: state => state.login_failure
    },
    actions: { login, getResource, loginFailureReset }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/devices.scss';
  @import '../../assets/scss/elements/button.scss';
  @import '../../assets/scss/elements/input.scss';

  .login{
    position: relative;
    padding: 1px 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
    height: calc(100vh - 110px);
    min-height: 860px;
    background: url(../../assets/img/chameleon_big.jpg) no-repeat center right;
    background-size: cover;
    box-sizing: border-box;

    &__form{
      position: absolute;
      top: 0;
      width: 100%;
      background: rgba(0,0,0,0.3);
      text-align: right;
      padding: 15px 45px;
      box-sizing: border-box;

      &__input{
        @extend .input;
        width: 250px;

        @include desktop {
          width: 275px;
        }
      }

      &__button{
        margin-right: 10px;
      }

      a{
        color: $white;
      }
    }

    &__failure{
      width: 800px;
      text-align: center;
      margin: 5px auto -12px;
      color: $green;
      font-size: 13px;
    }

  }

  .login-failure{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.8);
    &__block{
      background: $brown-light;
      padding: 50px;
      width: 550px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
      box-sizing: border-box;
    }

    &__text{
      margin: 0 0 35px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?4977292c